<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family05.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 2000,
						end: 2400,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(0)' },
           				toStyle: { transform: 'translateX(0%) translateY(0%) scale(1)' },
						easing: 'linear'
					},
					{
						start: 3200,
						end: 3600,
						fromStyle: { transform: 'translateX(0%) translateY(0%) scale(1)' },
           				toStyle: { transform: 'translateX(-50%) translateY(30%) scale(1)' },
						easing: 'linear'
					},
					{
						start: 3600,
						end: 4000,
						fromStyle: { transform: 'translateX(-50%) translateY(30%) scale(1)' },
           				toStyle: { transform: 'translateX(-100%) translateY(100%) scale(1)' },
						easing: 'linear'
					},
					{
						start: 4000,
						end: 4900,
						fromStyle: { transform: 'translateX(-100%) translateY(100%) scale(1)' },
           				toStyle: { transform: 'translateX(-1000%) translateY(100%) scale(1)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 130px;
		position: absolute;
		left: 27%;
		top: 0%;
		z-index: 2;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
        .slide-polaroid {
        	max-width: 100px;
        	top: 4%;
        }
    }

    @media screen and (max-width: 1280px) {
        .slide-polaroid {max-width: 60px;}
    }

    @media screen and (max-width: 650px) {
		.slide-polaroid {max-width: 35px;}
	}
</style>
